<template>
    <a href="#" class="button secondary add-to-cart-button" rel="nofollow" @click.prevent="addToCart">
        <img v-bind:src="btnIcon" v-svg-inline>
        <template v-if="showBtnText === true">{{ btnText }}</template>
    </a>

</template>

<script>
import {inject, onMounted, reactive, ref, toRefs} from 'vue'
import axios from 'axios';
import {isJson} from "../../../functions";
import emitter from '../../utils/emitter';

export default {
    props: {
        route: {required: true},
        productId: {required: true},
        btnText: {required: true},
        btnIcon: {required: true},
        showBtnText: {required: true},
        gtmDataP: null
    },

    setup(props) {
        const quantity = ref(1)
        const state = reactive({
            gtmData: null,
        })

        const emitter2 = inject('emitter')

        onMounted(() => {
            emitter.on('updateQuantity', data => {
                quantity.value = data.value
                state.gtmData.items[0].quantity = data.value
            })

            if ( isJson(props.gtmDataP) ) {
                state.gtmData = JSON.parse(props.gtmDataP)
            } else {
                state.gtmData = props.gtmDataP
            }
        })

        function addToCart() {
            axios.post(`/kosik/pridat-do-kosika/${props.productId}`, {
                id: props.productId,
                quantity: typeof quantity.value !== 'undefined' ? quantity.value : 1,
                type: 'product'
            }).then(response => {
                emitEvent(response)
                if(response.data.error && response.data.popup){
                    let htmlObject = document.createElement('div');
                    htmlObject.innerHTML = response.data.popup;
                    document.body.appendChild(htmlObject);
                }
                else{
                    emitter.emit('productAdded', response.data);
                    emitter.emit('updateBasket', response.data.quantity)
                }
            }).catch(error => {
                console.log(error)
                emitEvent()
            })
        }

        const emitEvent = () => {
            emitter2.emit('track-event', {
                data: state.gtmData,
                event: 'addToCart'
            })
        }

        return {
            ...toRefs(state),
            addToCart
        }
    }
}
</script>
